import {BaseApiModel} from "../../../../infrastructure/models/base-api-model";

export class LocaleApiModel extends BaseApiModel {
  cultureName: String;
  userCountryId: Number;

  constructor(apiModel: LocaleApiModel, cultureName: String) {
    super();

    this.userCountryId = apiModel.userCountryId;
    this.cultureName = cultureName;
  }
}
